var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    // Affirm cart drawer messaging
    if (affirm.ui.refresh) {
      affirm.ui.refresh();
    }

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('focus', () => adjustInputPosition(this.input));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = 'United States'; // Set the default country to "United States"
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.cm_toggle-dropdown)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
  
    if (this.sliderControlWrapper != null) {
      this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
      );
      this.sliderControlLinksArray.forEach((link) =>
        link.addEventListener('click', this.linkToSlide.bind(this))
      );
    }
  
    if (!this.slider) return;
  
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
  
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
    this.slider.addEventListener('scroll', this.update.bind(this));
  
    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.thumbnails =
      this.slider.classList.contains('thumbnail-list') &&
      window.innerWidth > 1359;
    this.heightOrWidth = this.thumbnails ? 'clientHeight' : 'clientWidth';
    this.direction = this.thumbnails ? 'top' : 'left';
    this.offsetDirection = this.thumbnails ? 'offsetTop' : 'offsetLeft';
    this.scrollAxis = this.thumbnails ? 'scrollTop' : 'scrollLeft';
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element[this.heightOrWidth] > 0
    );

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1][this.offsetDirection] -
      this.sliderItemsToShow[0][this.offsetDirection];
    this.slidesPerPage = Math.floor(
      (this.slider[this.heightOrWidth] -
        this.sliderItemsToShow[0][this.offsetDirection]) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.classList.contains('is-slider')) {
      this.initDots();
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    if (this.classList.contains('is-slider')) {
      this.initDots();
    }
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider[this.scrollAxis] / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );

      // Update mobile progress bar
      if (document.getElementById('myBar') != null) {
        const progressBar = (this.currentPage / this.totalPages) * 100;
        document.getElementById('myBar').style.width = progressBar + '%';
      }
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    let sliderControlWrapper = this.querySelector('.slider__control-wrapper');

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((link, index) => {
        if (index == this.currentPage - 1) {
          this.sliderControlButtons[index].classList.add(
            'slider-counter__link--active'
          );
          this.sliderControlButtons[index].setAttribute('aria-current', true);

          if (sliderControlWrapper) {
            sliderControlWrapper.scrollLeft =
              this.sliderControlButtons[index].offsetLeft;
          }
        } else {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        }
      });
    }

    if (this.enableSliderLooping || (!this.prevButton && !this.nextButton))
      return;

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((link, index) => {
        if (index == this.currentPage - 1) {
          this.sliderControlButtons[index].classList.add(
            'slider-counter__link--active'
          );
          this.sliderControlButtons[index].setAttribute('aria-current', true);
        } else {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        }
      });
    }

    if (this.enableSliderLooping || (!this.prevButton && !this.nextButton))
      return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider[this.scrollAxis] === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider[this.heightOrWidth] + this.slider[this.scrollAxis] - offset;
    return (
      element[this.offsetDirection] + element[this.heightOrWidth] <=
        lastVisibleSlide &&
      element[this.offsetDirection] >= this.slider[this.scrollAxis]
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 4;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider[this.scrollAxis] + step * this.sliderItemOffset
        : this.slider[this.scrollAxis] - step * this.sliderItemOffset;
    this.slider.scrollTo({
      [this.direction]: this.slideScrollPosition,
    });
  }

  initDots() {
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.sliderDotsWrapper = this.querySelector('.slider-dots');

    if (this.sliderDotsWrapper != null) {
      this.sliderDotsWrapperArray = Array.from(
        this.sliderDotsWrapper.querySelectorAll('.slider-counter__link')
      );
      this.sliderDotsWrapperArray.forEach((link) =>
        link.addEventListener('click', this.linkToSlide.bind(this))
      );
    }

    this.querySelectorAll('.slider-counter__link--dots').forEach(
      (dot, index) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          this.linkToSlide(event, true);
        });
      }
    );
  }

  linkToSlide(event, isDot = false) {
    const controlsArray = isDot
      ? this.sliderDotsWrapperArray
      : this.sliderControlLinksArray;
    event.preventDefault();
    const index = controlsArray.indexOf(event.currentTarget);
    const slideScrollPosition =
      index === 0
        ? 0
        : this.slider[this.scrollAxis] +
          this.sliderFirstItemNode[this.heightOrWidth] *
            (index + 1 - this.currentPage);
    this.slider.scrollTo({
      [this.direction]: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton;
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton;
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (this.classList.contains('rebuy-cart-item')) {
      this.addEventListener('change', this.onRebuyVariantChange);
      this.onRebuyVariantChange();
    } else {
      this.addEventListener('change', this.onVariantChange);
    }
  }

  onRebuyVariantChange() {
    this.updateRebuyItem();
  }

  updateRebuyItem() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const priceElement = productForm.querySelector('.rebuy-product-price');

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.variantStrings.unavailable, false);
        if (priceElement) {
          priceElement.textContent = '';
        }
      } else {
        this.toggleAddButton(false, '', true);
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        if (priceElement) {
          priceElement.textContent =
            ' - ' + Shopify.formatMoney(this.currentVariant.price);
        }
      }
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCompatibleSystems();
    }
  }

  updateCompatibleSystems() {
    let compatibleSystems = document.querySelector('compatible-systems');

    if (compatibleSystems) {
      compatibleSystems.filterProducts(this.currentVariant.id);
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId(rebuyItem = false) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (rebuyItem) {
      if (!this.currentVariant) {
        this.toggleAddButton(true, window.variantStrings.unavailable, false);
      } else {
        this.toggleAddButton(false, '', true);
        alert(`Product price: ${this.currentVariant.price}`);
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateRebate(html) {
    const rebate = html.querySelector('.rebate-badge-on-pdp');
    const rebateContainer = document.querySelector('.rebate-badge-on-pdp');
    if (rebate && rebateContainer) {
      rebateContainer.innerHTML = rebate.innerHTML;
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateRebate(html);
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // Stock message
        let soldOutString = window.variantStrings.soldOut
                
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
          inventoryDestination.classList.remove('hide');
          if(document.querySelector('[data-waterman-product]')) {
            this.toggleAddButton(
              true,
              window.variantStrings.callUs
            );
          }
          else {
            this.toggleAddButton(
              !this.currentVariant.available,
              soldOutString
            );
          }
        }

        const skus = document.getElementsByClassName(
          `sku-${this.dataset.section}`
        );
        const className = `sku-${this.dataset.section}`;
        const destinations = document.getElementsByClassName(className);
        const sources = html.getElementsByClassName(className);

        for (let i = 0; i < destinations.length; i++) {
          if (sources[i] && destinations[i]) {
            destinations[i].innerHTML = sources[i].innerHTML;
          }
        }
        this.updateStickyATC(html, this.currentVariant);
      });

    // Toggle shipping visibility based on price
    const shippingEl = document.getElementById(`Shipping-${this.dataset.section}`);
    if (shippingEl) {
      const priceCents = this.currentVariant?.price;
      const THRESHOLD = free_shipping_threshold;
      if (!priceCents || priceCents <= THRESHOLD) {
        shippingEl.classList.add('hide');
      } else {
        shippingEl.classList.remove('hide');
      }
    }
  }

  updateStickyATC(html, variant) {
    // Sticky Variant Options
    const destination = document.querySelector(
      `.sticky-variant-${this.dataset.section}`
    );
    const source = html.querySelector(
      `.sticky-variant-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    );
    if (source && destination) destination.innerHTML = source.innerHTML;

    // Sticky Image
    const stickyAtcImage = document.querySelector('.sticky-atc-desktop img');
    if (!stickyAtcImage) return;
    stickyAtcImage.src = variant.featured_image.src;
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const stickyAtcBtn = document.querySelector('.sticky-atc__btn')
    const stickyAtcBtnText = document.querySelector('.sticky-atc__btn > span')    
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      stickyAtcBtn.setAttribute('disabled', 'disabled');      
      if (text) addButtonText.textContent = text;
        stickyAtcBtnText.textContent = text;      
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;


      stickyAtcBtn.removeAttribute('disabled');
      stickyAtcBtnText.textContent = window.variantStrings.addToCart;      
      // Stock message
    }
    affirm.ui.refresh();
    if (!modifyClass) return;
  }

  setUnavailable() {
    const stockMessage = document.getElementById(
      `Inventory-${this.dataset.section}`
    );

    if (stockMessage) stockMessage.classList.add('hide');

    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    document
      .querySelectorAll(`.sticky-price-${this.dataset.section}`)
      .forEach((el) => el.classList.add('visibility-hidden'));    
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function openModal() {
  const modal = document.querySelector('#PopupModal-collection-modal');
  if (modal) modal.setAttribute('open', '');
}

function handleClick(e) {
  e.preventDefault();
  const garageSelector =
    window.innerWidth >= 750 ? '#cm-garage' : '#cm-mobile-garage';
  const convo_dropdown = document.querySelector(garageSelector);
  const convo_popup = convo_dropdown.querySelector('.cm_toggle-dropdown');
  convo_popup.click();
}

waitForElm('.cm_toggle-dropdown').then((elm) => {
  const localStorageKey = 'cm_variant-garage';
  const hasVehicleAdded = localStorage.getItem(localStorageKey) !== null;

  setTimeout(openModal, 3000);

  const modalButton = document.querySelector('[href="/add-my-vehicle"]');
  if (modalButton) {
    if (hasVehicleAdded) {
      modalButton.textContent = 'Add another vehicle';
    }
    modalButton.addEventListener('click', handleClick);
  }
});

class VariantsSelectors extends HTMLElement {
  constructor() {
    super();

    this.selects = this.querySelectorAll('select');

    if (this.selects) {
      for (const select of this.selects) {
        select.addEventListener('change', (e) => {
          window.location.href = e.target.value;
        });
      }
    }
  }
}

customElements.define('variants-selectors', VariantsSelectors);

class BackInStockForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        let formData = new FormData(e.target),
          email = formData.get('email'),
          variantId = formData.get('variant_id');

        e.preventDefault();

        fetch(
          'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          {
            method: 'POST',
            headers: {
              Accept: 'application/json, text/plain, */*',
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams({
              a: 'TTG7bP',
              email: email,
              variant: variantId,
              platform: 'shopify',
            }),
          }
        )
          .then((resp) => resp.json())
          .then((resp) => {
            if (resp.success) {
              this.form.classList.remove('error');
              this.form.classList.add('success');
            } else {
              this.form.classList.remove('success');
              this.form.classList.add('error');
            }
          });
      });
    }
  }
}

customElements.define('back-in-stock-form', BackInStockForm);

function triggerKlaviyoForm(formId) {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
}

document.addEventListener('DOMContentLoaded', (e) => {
  let logoutBtns = document.querySelectorAll('a[href^="/account/logout"]');

  if (logoutBtns) {
    for (const logoutBtn of logoutBtns) {
      logoutBtn.addEventListener('click', (e) => {
        let returnUrl = e.target.dataset.returnUrl;

        if (returnUrl) {
          e.preventDefault();

          fetch(logoutBtn.href).then(() => (window.location.href = returnUrl));
        }
      });
    }
  }

});

class FormNavigation extends HTMLElement {
  connectedCallback() {
    this.steps = this.getAttribute('data-steps').split(',');
    this.currentStep = 0;
    this.prevButton = document.querySelector('[data-action="previous"]');
    this.nextButton = document.querySelector('[data-action="next"]');
    this.prevButton.addEventListener('click', () => this.prevStep());
    this.nextButton.addEventListener('click', () => this.nextStep());
    this.updateButtons();
    this.render();
  }

  render() {
    this.textContent = `Step ${this.currentStep + 1}: ${
      this.steps[this.currentStep]
    }`;
    document.querySelectorAll(`[data-step]`).forEach((el) => {
      el.style.display =
        el.getAttribute('data-step') == this.currentStep ? 'grid' : 'none';
    });
    this.updateProgressBar();
  }

  updateProgressBar() {
    const progressBar = document.querySelector('.progress-bar');
    const progress = (this.currentStep / (this.steps.length - 1)) * 100;
    progressBar.value = progress;
    progressBar.textContent = `${progress}%`;
  }

  nextStep() {
    const currentStepElements = document.querySelectorAll(
      `[data-step="${this.currentStep}"]`
    );
    let firstInvalidInput = null;

    currentStepElements.forEach((field) => {
      const inputElements = field.querySelectorAll('[required]');

      inputElements.forEach((inputElement) => {
        // Clear the custom validity message as soon as the user starts typing
        inputElement.addEventListener('input', () => {
          inputElement.setCustomValidity('');
        });

        if (!inputElement.checkValidity() && !firstInvalidInput) {
          // Set the focus to the first invalid input
          firstInvalidInput = inputElement;
          // Show an error message
          inputElement.setCustomValidity('This field is required');
          inputElement.reportValidity();
        }
      });
    });

    if (!firstInvalidInput && this.currentStep < this.steps.length - 1) {
      this.currentStep++;
      this.updateButtons();
      this.render();
      this.updateScreenPosition();
    }
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateButtons();
      this.render();
      this.updateScreenPosition();
    }
  }

  updateScreenPosition() {
    window.scrollTo({
      top: this.closest('section').offsetTop - 200,
      behavior: 'instant',
    });
  }

  updateButtons() {
    this.prevButton.disabled = this.currentStep == 0;
    this.nextButton.disabled = this.currentStep == this.steps.length - 1;
  }
}

customElements.define('form-navigation', FormNavigation);

if (document.querySelector('#AddressProvinceNew')) {
  const countryProvinceSelector = new Shopify.CountryProvinceSelector(
    'AddressCountryNew',
    'AddressProvinceNew',
    {
      hideElement: 'AddressProvinceNew',
    }
  );
  if (countryProvinceSelector.countryEl) {
    countryProvinceSelector.countryEl.dispatchEvent(new Event('change'));
  }
}

class OverflowIndicator extends HTMLElement {
  constructor() {
    super();

    let element = this;

    if (element) {
      let slider = element.children[0];

      slider.addEventListener('scroll', (e) => {
        element.classList.toggle('is-overflowing', this.isOverflown(slider));
        if (this.isOverflown(slider)) {
          element.classList.toggle(
            'is-left-overflowing',
            slider.scrollLeft > 0
          );
          element.classList.toggle(
            'is-right-overflowing',
            !(
              slider.scrollWidth - slider.clientWidth ==
              Math.round(slider.scrollLeft)
            )
          );
        }
      });

      slider.dispatchEvent(new Event('scroll'));

      let mouseDown = false;
      let startX, scrollLeft;

      let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      let stopDragging = function (event) {
        mouseDown = false;
      };

      slider.addEventListener('mousemove', (e) => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      });

      // Add the event listeners
      slider.addEventListener('mousedown', startDragging, false);
      slider.addEventListener('mouseup', stopDragging, false);
      slider.addEventListener('mouseleave', stopDragging, false);
    }
  }

  isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) =>
    scrollHeight > clientHeight || scrollWidth > clientWidth;
}

customElements.define('overflow-indicator', OverflowIndicator);

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.searchParams = new URLSearchParams(location.search);

    this.previousUrl = this.dataset.previousUrl;
    this.nextUrl = this.dataset.nextUrl;
    this.currentPage = this.dataset.currentPage;
    this.currentUrl = this.dataset.currentUrl;

    this.targetList = this.querySelector('ul');
    this.elementToObserve = this.querySelector('.infinite-scroll--observed');
    this.loadPrevious = this.querySelector('[data-load-previous]');
    this.loadNext = this.querySelector('[data-load-next]');
    this.loadPreviousButton = this.querySelector(
      '[data-load-previous] .button'
    );
    this.loadNextButton = this.querySelector('[data-load-next] .button');
    this.statusContainer = this.querySelector('.infinite-scroll--status');

    this.storedPage = this.searchParams.get('page');

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (
      this.searchParams.get('page') &&
      parseInt(this.searchParams.get('page')) > 1
    ) {
      this.loadPrevious.classList.remove('hide');

      this.loadPrevious
        .querySelector('button')
        .addEventListener('click', (e) => {
          e.preventDefault();

          this.handlePrevious();
        });
    }

    this.bindCardClickEvents();
  }

  connectedCallback() {
    if (this.loadNext && this.loadNextButton) {
      this.loadNext.querySelector('button').addEventListener('click', (e) => {
        this.handleNext();
      });
    } else {
      if (this.elementToObserve) {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          this.handleNext();
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: '0px 0px 400px 0px',
        }).observe(this.elementToObserve);
      }
    }
  }

  loadingState(button, enable) {
    this.querySelector('.load-more-button') &&
      button.setAttribute('aria-disabled', enable);
    this.loadNext
      .querySelector('.loading-overlay__spinner')
      .classList.toggle('hidden', !enable);
  }

  handlePrevious() {
    this.loadingState(this.loadPreviousButton, true);

    fetch(this.currentUrl + '?page=' + (this.storedPage - 1))
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        let docInfiniteScroll = doc.querySelector('infinite-scroll');

        if (docInfiniteScroll.dataset.currentPage == '1') {
          this.loadPrevious.classList.add('hide');
        }

        this.storedPage = this.storedPage - 1;

        if (this.storedPage != 1) {
          this.searchParams.set('page', this.storedPage);
        } else {
          this.searchParams.delete('page');
        }
        window.history.replaceState(
          {},
          '',
          `${location.pathname}?${this.searchParams}`
        );

        if (this.targetList) {
          this.targetList.insertAdjacentHTML(
            'afterbegin',
            docInfiniteScroll.querySelector('ul').innerHTML
          );
        }

        this.loadedCallback();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleNext() {
    if (this.nextUrl) {
      this.loadingState(this.loadNextButton, true);

      fetch(this.nextUrl)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          let docInfiniteScroll = doc.querySelector('infinite-scroll');

          this.previousUrl = docInfiniteScroll.dataset.previousUrl;
          this.nextUrl = docInfiniteScroll.dataset.nextUrl;
          this.currentPage = docInfiniteScroll.dataset.currentPage;

          if (this.currentPage != '1') {
            this.searchParams.set('page', this.currentPage);
          }

          window.history.replaceState(
            {},
            '',
            `${location.pathname}?${this.searchParams}`
          );
          if (this.targetList)
            this.targetList.insertAdjacentHTML(
              'beforeend',
              docInfiniteScroll.querySelector('ul').innerHTML
            );
          this.statusContainer.innerHTML = docInfiniteScroll.querySelector(
            '.infinite-scroll--status'
          ).innerHTML;

          if (!this.nextUrl) {
            this.loadNext.remove();
          }

          this.loadedCallback();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  loadedCallback() {
    this.loadPreviousButton &&
      this.loadingState(this.loadPreviousButton, false);
    this.loadingState(this.loadNextButton, false);

    this.bindCardClickEvents();
  }

  bindCardClickEvents() {
    let cards = this.querySelectorAll('.product-grid li a');

    if (cards) {
      for (const card of cards) {
        card.addEventListener('click', (e) => {
          let link = e.target.href;
          let liItem = e.target.closest('li');

          if (liItem && liItem.dataset.currentPage) {
            e.preventDefault();

            let currentPage = liItem.dataset.currentPage;

            this.searchParams.set('page', currentPage);

            window.history.replaceState(
              {},
              '',
              `${location.pathname}?${this.searchParams}`
            );

            window.location.href = link;
          }
        });
      }
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

class CompatibleSystems extends HTMLElement {
  constructor() {
    super();

    this.productGrid = this.querySelector('.product-grid');
    this.variantId = parseInt(this.dataset.variantId);
    this.maxProducts = parseInt(this.dataset.maxProducts);

    this.pageLoad = 1;
    this.products = [];

    this.loadSystemDiagramProducts();
  }

  loadSystemDiagramProducts() {
    this.getSystemDiagramProducts(this.pageLoad).then((x) => {
      this.products.push(...x);

      if (x.length == 20) {
        this.pageLoad++;

        this.loadSystemDiagramProducts();
      } else {
        this.loadingCallback();
      }
    });
  }

  getSystemDiagramProducts = (page) =>
    fetch(
      `/collections/${this.dataset.collectionHandle}?view=system-diagrams&page=${page}`
    )
      .then((x) => x.text())
      .then((x) => JSON.parse(x));

  loadingCallback() {
    this.filterProducts(this.variantId);
  }

  async filterProducts(variantId) {
    this.loadedAmount = 0;

    this.productGrid.innerHTML = '';

    const productCardPromises = this.products
      .map((product) => {
        if (
          product.sd_pump_products_handles.includes(variantId) &&
          this.loadedAmount <= this.maxProducts
        ) {
          this.classList.remove('hidden');
          this.loadedAmount++;
          return this.getProductCard(product.sd_product_handle).then((x) =>
            this.renderProductCard(x, product.sd_product_handle)
          );
        }
      })
      .filter(Boolean);

    await Promise.all(productCardPromises);

    if (this.loadedAmount == 0) {
      this.classList.add('hidden');
    } else {
      const slider = this.querySelector('#compatible-systems');
      if (slider) {
        const newElement = document.createElement('slider-component');
        Array.from(slider.attributes).forEach((attr) =>
          newElement.setAttribute(attr.name, attr.value)
        );
        while (slider.firstChild) newElement.appendChild(slider.firstChild);
        slider.parentNode.replaceChild(newElement, slider);
      }
    }
  }

  getProductCard = (productHandle) =>
    fetch(`/products/${productHandle}?view=card`).then((x) => x.text());

  renderProductCard(cardHtml, handle) {
    this.productGrid.innerHTML += `
      <li id="Slide-${handle}" class="grid__item slider__slide">
        ${cardHtml}
      </li>
    `;
  }
}

customElements.define('compatible-systems', CompatibleSystems);

// Header search bar
window.handleSearchClick = function () {
  // Trigger click event on .cm_searchBoxDialogButton
  var searchInput = document.querySelector('.cm_searchBoxDialogButton');
  if (searchInput) {
    searchInput.click();
  }

  setTimeout(function () {
    // Set up event listener on all .cm_searchInput elements
    document.querySelectorAll('.cm_searchInput').forEach(function (input) {
      input.addEventListener('input', function () {
        document.querySelector('.mobile-search-input input').value = this.value;
      });
    });
  }, 500); // Adjust this delay as needed
};

window.handleSearchSubmitClick = function (event) {
  // Stop event bubbling
  event.stopPropagation();

  // Trigger click event on .cm_search-box_submit
  var searchSubmitButton = document.querySelector('.cm_search-box_submit');
  if (searchSubmitButton) {
    searchSubmitButton.click();
  }
};

function adjustInputPosition(input) {
  setTimeout(() => {
    const keyboardHeight = window.visualViewport.height - window.innerHeight;
    const inputRect = input.getBoundingClientRect();
    const scrollPosition = window.scrollY + inputRect.top - (window.innerHeight - inputRect.height) - keyboardHeight + 10;

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }, 200);
}

const syncQuantityInputs = (input) => {
  const id = input.id;
  const isSticky = id.startsWith('StickyQuantity-');
  const targetId = isSticky
    ? id.replace('StickyQuantity-', 'Quantity-')
    : id.replace('Quantity-', 'StickyQuantity-');

  const target = document.getElementById(targetId);
  if (target && target.value !== input.value) {
    target.value = input.value;
    ['input', 'change'].forEach((evt) =>
      target.dispatchEvent(new Event(evt, { bubbles: true }))
    );
  }
};

document
  .querySelectorAll('input[id^="StickyQuantity-"], input[id^="Quantity-"]')
  .forEach((input) => {
    input.addEventListener('change', (event) =>
      syncQuantityInputs(event.target)
    );
  });

// Replace search input labels based on selected vehicle
(function () {
  var labels = Array.from(document.querySelectorAll('.search__input + label'));
  if (!labels.length) return;

  var defaults = labels.map(function (l) { return l.textContent; });
  var prefix = 'Search parts for your ';
  var KEY = 'cmVehicleText';
  var last = null;

  function apply(txt) {
    if (txt === last) return;
    last = txt;
    labels.forEach(function (label, i) {
      var val = txt || defaults[i];
      label.textContent = val;
      if (txt) label.title = val; else label.removeAttribute('title');
    });
  }

  // 1) Instant prefill from storage (avoids flash)
  try {
    var cached = sessionStorage.getItem(KEY);
    if (cached) apply(cached);
  } catch (e) {}

  // 2) Poll Convermax, keep in sync, stop after 5s if not found
  var start = Date.now();
  var poll = setInterval(function () {
    var cm = window.Convermax;

    if (!cm || !cm.loaded || !cm.initialized) {
      if (Date.now() - start > 5000) clearInterval(poll);
      return;
    }

    var txt = null;
    if (cm.isVehicleSelected && cm.isVehicleSelected() && cm.getVehicle) {
      var v = cm.getVehicle() || {};
      var year  = (v.Year  || '').toString().trim();
      var model = (v.Model || v.Trim || '').toString().trim();
      var formatted = (year + ' ' + model).trim();
      if (formatted) txt = prefix + formatted;
    }

    apply(txt);

    // update storage (or clear on reset)
    try {
      if (txt) sessionStorage.setItem(KEY, txt);
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }, 300);
})();
